"use strict";
const setup = () => {
  const nav = document.querySelector(".focasos-web-nav");
  if (!nav || nav.dataset.ready) {
    return;
  }
  nav.dataset.ready = "true";
  const toggleButton = nav.querySelector(".focasos-web-nav__abrir");
  const subButtons = [...nav.querySelectorAll(".focasos-web-menu__desplegar")];
  const closeSubs = (except) => subButtons.forEach((button) => {
    if (button !== except) {
      button.setAttribute("aria-expanded", "false");
    }
  });
  toggleButton == null ? void 0 : toggleButton.addEventListener("click", () => {
    const open = toggleButton.getAttribute("aria-expanded") !== "true";
    toggleButton.setAttribute("aria-expanded", String(open));
    nav.classList.toggle("is-open", open);
    if (!open) {
      closeSubs();
    }
  });
  subButtons.forEach((button) => button.addEventListener("click", () => {
    const open = button.getAttribute("aria-expanded") !== "true";
    closeSubs(button);
    button.setAttribute("aria-expanded", String(open));
  }));
  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") {
      return;
    }
    const openSub = subButtons.find((button) => button.getAttribute("aria-expanded") === "true");
    if (openSub) {
      openSub.setAttribute("aria-expanded", "false");
      openSub.focus();
    } else if (nav.classList.contains("is-open")) {
      toggleButton.click();
      toggleButton.focus();
    }
  });
  document.addEventListener("click", (event) => {
    if (!nav.contains(event.target)) {
      closeSubs();
    }
  });
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", setup);
} else {
  setup();
}
